@if (!editMode) {
  <div>
    {{ data }}
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup">
    <mat-select formControlName="{{ fieldConfig.name }}" data_id="select" [errorStateMatcher]="matcher">
      @for (option of options; track option) {
        <mat-option [attr.data-id]="'option_' + option" [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-select>
    @if (!isDisabled) {
      <mat-icon matSuffix class="info-icon" matTooltip="Clear" (click)="clearField()">clear</mat-icon>
    }
    @for (v of fieldConfig.validators; track v) {
      <mat-error>
        @if (condition(v)) {
          <span>{{ message(v) }}</span>
        }
      </mat-error>
    }
  </mat-form-field>
}
